import axios from "axios";
import env from "../variables/EndpointEnvironment";

const InvestorsBannerAPI = () => {
    return axios.get(`${env.HOST}/hubungan-investor`, {
        headers: {
            "Content-Language": localStorage.getItem('i18nextLng'),
        },
    });
};

export default InvestorsBannerAPI;